import React from 'react';
/**
 * We are still seeing unexpected token errors in jest tests which could be
 * due to @babel problems that haven't been resolved or implemented
 */
import { css } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import { ProfileCardWrapper } from '@confluence/profile/entry-points/ProfileCardWrapper.ts';

import { ColumnWidths, TaskColumn } from './tasksDefinitions.ts';
import { PageColumn } from './PageColumn.tsx';
import { CellContainerCompiled } from './presentationalComponents.tsx';
import { HeightAdjustingText } from './HeightAdjustingText.tsx';
import { TruncatedTextCacheKeys } from './TaskRowsContext.tsx';

interface MainColumnProps {
	taskId: string;
	task: any;
	mainColumn: TaskColumn;
}

const pageTitleContainerStyles = css({
	color: token('color.text'),
	paddingLeft: token('space.050'),
});

export const MainColumn = ({ task, taskId, mainColumn }: MainColumnProps) => {
	if (!task || !taskId) {
		return null;
	}

	switch (mainColumn) {
		case TaskColumn.Page:
			return (
				<PageColumn
					taskId={taskId}
					page={task.container?.title ?? ''}
					url={`${task.container?.links?.base}${task.container?.links?.webUi}`}
				/>
			);
		case TaskColumn.Space:
			return (
				<CellContainerCompiled>
					{/* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values */}
					<span css={pageTitleContainerStyles} style={{ width: ColumnWidths.Main }}>
						<HeightAdjustingText
							taskId={taskId}
							defaultText={task.container?.space?.name ?? ''}
							cacheKey={TruncatedTextCacheKeys.SPACE}
							url={`${task.container?.space?.links?.base}${task.container?.space?.links?.webUi}`}
						/>
					</span>
				</CellContainerCompiled>
			);
		case TaskColumn.Assignee:
			return (
				<CellContainerCompiled>
					{/* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values */}
					<span css={pageTitleContainerStyles} style={{ width: ColumnWidths.Main }}>
						<ProfileCardWrapper
							userId={task.assignedTo?.accountId}
							fullName={task.assignedTo?.displayName ?? undefined}
							isAnonymous={!task.assignedTo?.accountId}
							canViewProfile
						>
							<HeightAdjustingText
								taskId={taskId}
								defaultText={task.assignedTo?.displayName ?? ''}
								cacheKey={TruncatedTextCacheKeys.ASSIGNEE}
							/>
						</ProfileCardWrapper>
					</span>
				</CellContainerCompiled>
			);
		case TaskColumn.Creator:
			return (
				<CellContainerCompiled>
					{/* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values */}
					<span css={pageTitleContainerStyles} style={{ width: ColumnWidths.Main }}>
						<ProfileCardWrapper
							userId={task.createdBy?.accountId}
							fullName={task.createdBy?.displayName ?? undefined}
							isAnonymous={!task.createdBy?.accountId}
							canViewProfile
						>
							<HeightAdjustingText
								taskId={taskId}
								defaultText={task.createdBy?.displayName ?? ''}
								cacheKey={TruncatedTextCacheKeys.CREATED_BY}
							/>
						</ProfileCardWrapper>
					</span>
				</CellContainerCompiled>
			);
	}
};
